import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import validator from 'validator';
import styled from 'styled-components';
import Text from '../shared/Text';
import { StyledFloatingLabel, StyledInput, ButtonWrapper, FlashWrapper } from '../shared/Password';
import ScreenWrapper from '../shared/ScreenWrapper';
import Button from '../shared/Button';
import styles from '../../utility/styles';
import StoreButton from '../shared/StoreButton';

const StyledContainer = styled(Container)`
    margin-top: 72px;
    margin-bottom: 72px;
    display: flex;
    flex: 1;
    justify-content: center;
`;

const StyledLink = styled.a`
    color: ${styles.colors.lightGray};
    text-decoration: underline;
    text-align: center;
`;

export default function Welcome({ meta={} }) {

    const [email, setEmail] = React.useState('');
    const [flash, setFlash] = React.useState('');
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const handleEmailChange = React.useCallback(({ target: { value } }) => {
        setEmail(value)
    }, [setEmail])

    const submitEmail = React.useCallback(async () => {
        try {
            setLoading(true);
            setFlash('');
            setError('');
            const response = await fetch('/v2/referral', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: email.trim(), ...meta })
            })
            if (!response.ok) throw 'Error Submitting Email'
            const json = await response.json();
            if (json && json.success) {
                setFlash(json.message)
            } else {
                setError(json.message)
            }
            setLoading(false);
        } catch (error) {
            setError(typeof error === 'string' ? error : 'Error Submitting Email');
            setLoading(false);
        }
    }, [email, setError, setFlash, setLoading])

    return (
        <ScreenWrapper>
            <StyledContainer>
                <Row style={{ maxWidth: '500px' }}>
                    <Col>
                        <Text.Heading type='h2' variant='bold' style={{ textAlign: 'center', color: styles.colors.white }}>Welcome to TezLab!</Text.Heading>
                        <Text.Body style={{ textAlign: 'center', color: styles.colors.whiteGray }}>Enter your email address and we'll send you a link to download TezLab on iOS or Android. Or, <StyledLink href="/">learn more</StyledLink> about the app.</Text.Body>
                       
                        <Form onSubmit={e=>e.preventDefault()}>
                            <StyledFloatingLabel
                                controlId='floatingEmailInput'
                                label='Email Address'
                            >
                                <StyledInput
                                    value={email}
                                    onChange={handleEmailChange}
                                    placeholder='user@example.com'
                                    type='email'
                                />
                            </StyledFloatingLabel>
                        </Form>
                        <ButtonWrapper>
                            <Button 
                                onClick={submitEmail} 
                                style={{ display: 'flex', flex: 1, marginBottom: '24px', padding: '12px' }} 
                                disabled={!validator.isEmail(email)}
                                {...{ loading }}
                            >
                                Get Download Link
                            </Button>
                        </ButtonWrapper>
                        {Boolean(flash) && (
                            <FlashWrapper variant='success'>
                                <Text.Caption>{flash}</Text.Caption>
                            </FlashWrapper>
                        )}
                        {Boolean(error) && (
                            <FlashWrapper variant='error'>
                                <Text.Caption>{error}</Text.Caption>
                            </FlashWrapper>
                        )}
                        <ButtonWrapper>
                          <StoreButton type='apple' />
                          <StoreButton type='android' />
                        </ButtonWrapper>
                    </Col>
                </Row>
            </StyledContainer>
        </ScreenWrapper>
    )
}